module.exports = "./images/logo-nubile.png";